<template>
  <div class="w-100 bg-white position-fixed">
    <div class="w-100 d-flex flex-row align-items-center p-3 container">
      <s-t-r-logo :size="36" />
      <div class="text-primary h4 ms-1 mb-0 title" style="font-weight:800">STR Enforcement</div>
      <router-link class="ms-auto nav-link fw-bold" :to="{name:'home'}">
        Log in
      </router-link>
    </div>
  </div>
  <div class="d-flex flex-column flex-grow-1 align-items-stretch">
    <div class="hero d-flex flex-column flex-grow-1">
      <div class="container flex-grow-1 d-flex flex-column align-items-center justify-content-center title text-dark text-center">
        <div class="title">Empowering municipalities</div>
        <div class="title mb-2"> one rental at a time</div>
        <div class="container text-center my-4 fw-light h3">Empower your staff while saving time and money.</div>
        <a href="mailto:paul@strenforcement.com" target="_blank" class="btn btn-primary btn-lg my-4">
          Get in touch
        </a>
      </div>
    </div>

    <div class="d-flex flex-column p-4 flex-grow-1 mb-4">
      <div class="container">
        <div class="row d-flex flex-row justify-content-center">
          <div class="col-12 col-md-9 col-lg-6 py-4">
            <p class="text-center mb-4" style="font-size:1.2rem">
              STR Enforcement has developed software to help you - and your staff - understand how short-term rentals may be impacting your community. This tool can quickly identify how many STRs you have and where they are located. With this knowledge, you can:
            </p>
            <div class="text-center h4 py-4 w-50 mx-auto">
              Determine if and how you may want to regulate STRs
            </div>
            <div class="text-center h4 py-4 w-50 mx-auto">
              Enforce your current regulations
            </div>
            <div class="text-center h4 py-4 w-50 mx-auto">
              Generate new fee revenue for your municipality
            </div>
            <div class="text-center h4 py-4 w-50 mx-auto">
              Provide the public with transparency around STRs
            </div>
            <p class="text-center py-4" style="font-size:1.2rem">
              Our software is offered at a fraction of the price of all our competitors with an easier user experience and better customer support.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <STRCopyright class="w-100 p-3 bg-light small text-center mt-4"/>
</template>
<script setup>
import STRLogo from "@/homepage/STRLogo.vue";
import STRCopyright from "@/homepage/STRCopyright.vue";
</script>

<style>
.hero {
  margin-top: 68px;
  width: 100% !important;
  min-height: 400px;
  padding-top: 68px;
}
.hero .title {
  font-size: 3.2rem;
  font-weight: 800;
  line-height: 72px;
  color: var(--bs-dark);
}
.hero .subtitle {
  font-size: 2rem;
  font-weight: 300;
  color: #000;
}
</style>
